<app-scroll-top></app-scroll-top>
<div class="about-us-page min-h-50">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Qui sommes nous ?</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-2 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading">
                            NOTRE <span style="color : #BADFFF"> HISTOIRE </span>
                        </h1>
                        <h6 class="description">
                            Nous partageons 35 ans d’amitié fidèle et une vraie passion pour l’immobilier. C’est notre
                            métier. Nous l’aimons. Nous sommes fiers de l’exercer.
                            <br><br>
                            Ensemble, nous avons passé des heures de discussions en analyse de notre profession en
                            matière d’organisation, de services, de communication, de montant d’honoraires et
                            d’évolution des besoins de nos clients.
                            <br><br>
                            Seule compte la volonté d'agir. Aussi, en 2015 nous nous sommes fixés comme objectif de
                            créer un réseau immobilier national disposant d’offres jusqu’ici inexistantes au sein d’une
                            même organisation immobilière, quelle que soit sa taille ou sa notoriété. C’est dans cet
                            esprit que nous avons construit THE DOOR MAN la nouvelle expérience immobilière.
                        </h6>
                    </div>
                    <div>
                    </div>
                </div>
                <div class="slider-img">
                    <img width="575" height="570" style="border-radius: 50% 50% 0% 0%;"
                        src="../../../../assets/resources/web/images/data/photopbpam.jpg" alt="Interieur cosi">
                </div>
            </div>
        </div>
    </div>
    <div class="about-us-bloc py-0 py-md-5">
        <div class="container content">
            <div class="formulaire text-start">
                <h3 class="heading">
                    NOTRE <span class="bleutdm"> CONCEPT </span>
                </h3>
                <div class="row">
                    <div class="col-12 col-md-8">
                      <div class="py-2 mt-3">
                        <p>Aujourd'hui, THE DOOR MAN est le premier réseau immobilier à proposer à tous ses clients vendeurs le libre choix entre :</p>
                        <ul>
                          <li><a [routerLink]="['/nos-formules-the-door-man.html']" fragment="mondat-flash">un mandat FLASH</a>, pour vendre leur bien via des enchères interactives en ligne,</li>
                          <li>ou <a [routerLink]="['/nos-formules-the-door-man.html']" fragment="mondat-premium">un mandat PREMIUM</a>, 100 % partagé avec l’ensemble des professionnels de l’immobilier confrères présents autour du bien confié à la vente.</li>
                        </ul>
                        <p>Notre ambition ? <span class="fw-medium">Vendre plus vite, en plus grand nombre, et dans les meilleures conditions économiques</span>.</p>
                        <p>Pour cela, nous combinons <span class="fw-medium">accompagnement humain de proximité, diffusion massive</span> des annonces, et <span class="fw-medium">innovations digitales</span> à chaque étape du parcours.</p>
                        <p>En tant que <span class="fw-medium">réseau de nouvelle génération</span>, nous avons fait le choix d’outils performants, sans les lourdeurs des anciens systèmes.</p>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 align-self-center">
                        <img width="425" height="236" style="    width: -webkit-fill-available; height: auto;"
                            src="../../../../assets/resources/web/images/data/Schéma-Concept_Qui-sommes-nous.png"
                            alt="Interieur cosi">
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="bloc-ami">
        <div class="container pb-4">
            <div class="row py-3">
                <h3 class="text-uppercase">L’<span class="bleutdm">AVENTURE</span> COMMENCE...
                </h3>
            </div>
            <div class="row row-cols-md-2 row-cols-sm-1 py-3">
                <div>
                    <!--    <div class="img-bg-bloc-ami"><div class="img-bloc-ami"></div></div>-->
                    <img width="651" height="537" src="assets/home/Concession.png" class="img-fluid" alt="Rencontrez nos Conseillers en immobilier">
                </div>
                <div class="align-self-md-center mt-2 mt-md-0">
                    <p>
                        <span class="fw-bold">Nous sommes prêts à nous investir pour vous.</span>
                        THE DOOR MAN c’est
                        <a class="a pe-auto" style="cursor: pointer; text-decoration: none;"
                            (click)="onNavigateRejoindre()">
                            une aventure humaine et un appel à NOUS REJOINDRE
                        </a>
                        également, lancé à tous les professionnels de l’immobilier
                        qui partagent nos valeurs. Nos résultats sont toujours la conséquence de votre satisfaction.
                        <br><br>
                        <span>Je vous invite à découvrir le détail des innovations que nous avons créées pour vous, dans
                            votre intérêt.<br><br>
                            <span class="fw-bold"> Notre objectif : </span>être efficace pour vous servir partout en
                            France. <br><br></span>
                        <span>Très bonne visite de notre site.

                        </span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</div>
